function createTimeOptions() {
    const timeOptions = [
        { value: 30, text: '30 minutes' },
        { value: 60, text: '1 hour' },
        { value: 90, text: '1.5 hours' },
        { value: 120, text: '2 hours' },
        { value: 180, text: '3 hours' },
        { value: 240, text: '4 hours' },
        { value: 300, text: '5 hours' },
    ];
    return timeOptions;
}

export const timeOptions = createTimeOptions();

export const rentalOptions = [
    { value: 'hourly', text: 'Hourly' },
    { value: 'monthly', text: 'Monthly' },
    { value: 'daily', text: 'Airport' },
];

export enum RentType {
    monthly = 'monthly',
    enterprise = 'enterprise',
    daily = 'daily',
    hourly = 'hourly',
    flatRate = 'flat rate',
    freeUntilHourly = 'free_until_hourly',
}

enum IntervalOption {
    ONE_TIME = 'one_time',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    ALWAYS_ON = 'always_on',
}

interface AddressInterface {
    address_line1: string;
    address_line2: string;
    city: string;
    country: string;
    latitude: string;
    longitude: string;
    state: string;
    zipcode: string;
}

enum PricingStrategy {
    SURGE_PRICING = 'surge_pricing',
    STANDARD = 'standard',
    EVENT = 'event',
    RATE = 'rate',
}

export interface Spot {
    name: string;
    uuid: string;
    description: string;
    address: AddressInterface;
    organization: number;
    pk: number;
    timezone: string;
    photo_url: string | null;
    notes: string;
    price_hourly: number;
    price_monthly: number | null;
    price_daily: number;
    display_daily_min: string;
    spaceforce_config: {
        spaceforce_multiplier: number;
        note_bounty_amount: number;
        scan_bounty_amount: number;
        immobilization_fee_amount: number;
        immobilization_bounty_amount: number;
        personal_scan_cooldown_minutes: number;
        note_left_cooldown_minutes: number;
        autostart_fee: number;
    };
    hidden: boolean;
    spaceforce_multiplier: number;
    dynamic_price: number;
    daily_max: number | null;
    display_price: string;
    dynamic_pricing_strategy: PricingStrategy;
    free_until_hourly_event: string | null;
    active_event: {
        is_effective_flat_rate: boolean;
        name: string;
        pk: number;
        price_formatted: string | null;
        price_transition_time: string | null;
        unit: string | null;
        is_lot_closed: boolean;
    } | null;
    dynamic_pricing_enabled: boolean;
    third_party_id: null;
    active_rate: null | {
        unit: RentType;
        interval: IntervalOption;
        display_price: string | null;
        subtext_override: string | null;
        pk: number;
    };
    webflow_page_url: string;
    is_recently_scanned: boolean;
    allowed_email_domains: [];
}

export interface BulkRentalAvailability {
    total_slots_available: number;
    total_slots_max: number;
    bulk_rental_slots_available: number | null;
    bulk_rental_slots_max: number | null;
    tenants_available: number | null;
    tenants_max: number | null;
}

export interface SpotAvailability {
    name: string;
    pk: number;
    timezone: string;
    monthly_rental_blackout_days: string[];
    bulk_rental_availability: BulkRentalAvailability;
}

export interface RentalOptionsData {
    value: string;
    text: string;
    link: string;
    buttonTitle: string;
}

export const contactTopics = [
    { value: 'Incorrect or Unrecognized Charge', text: 'Incorrect or Unrecognized Charge' },
    { value: 'Forgot to End Rental', text: 'Forgot to End Rental' },
    { value: 'Bug or Error', text: 'Bug or Error' },
    { value: 'Incorrect Parking Ticket', text: 'Incorrect Parking Ticket' },
    { value: 'Question About Rental', text: 'Question About Rental' },
    { value: 'Car Immobilized or Towed', text: 'Car Immobilized or Towed' },
    { value: 'Discount / Validation Code Issue', text: 'Discount / Validation Code Issue' },
    { value: 'Other', text: 'Other' },
];

export const invoiceTypes = [
    { value: 'Subscription', text: 'Subscription' },
    { value: 'Invoice', text: 'One-time invoice' },
    { value: 'Log', text: 'Log an outside payment' },
];

export const AGGREGATOR_SOURCE_LIST = ['SpotHero', 'CheapAirportParking', 'AirportParkingReservations'];

export const VISITOR_FORM_VALIDATION_SOURCE = 'visitor-form';

export const currentYear = new Date().getFullYear();

export const AG_HELP_CENTER_LINK = 'http://help.airgarage.com/';

export const ANOTHER_PROMO_ALREADY_APPLIED = 'Another discount code already applied to this rental.';

export const AIRPORT_LOT = 'Airport Lot';

export const paymentMethodOptions = [
    { key: 'us_bank_account', value: 'us_bank_account', text: 'Bank Account (Recurring Payments)' },
    { key: 'card', value: 'card', text: 'Credit or Debit Card' },
    { key: 'paper_check', value: 'paper_check', text: 'Paper Check' },
    { key: 'ach_credit_transfer', value: 'ach_credit_transfer', text: 'Wire Transfer (One-Time Payment)' },
];

export const rentalTypeOptions = [
    { value: 'hourly', text: 'Hourly' },
    { value: 'daily', text: 'Daily' },
    { value: 'monthly', text: 'Monthly' },
    { value: 'flat rate', text: 'Flat Rate' },
];
